import React, { useState } from "react";
import Moment from "moment";
import { dbfileSize, DetailsMarkstarida } from "../../actions";
import testJson from "../../actions/testJson";
import Lightbox from "react-image-lightbox";
import JPG from "../../build/images/jpg-file.png";
import XLS from "../../build/images/media-icon.png";
import PDF from "../../build/images/pdf-file.png";
import MP3 from "../../build/images/mp3-file.png";
import AVI from "../../build/images/avi-file.png";
import { useDispatch, useSelector } from "react-redux";
import convertUnicodeEmoji from "../../actions/convertUnicodeEmoji";
import MicroModal from "micromodal";

const { connection_platform } = require("../../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern
var port = connection_platform.port_backend_intern;

if(gethostname === 'localhost')
  pathname = iplocal;
else
  pathname = gethostname;

var ipcurrent = pathname;

if(pathname !== connection_platform.ip_intern){
    ipcurrent = connection_platform.ip_apache_view_extern;
   // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
       ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_extern;
    //}
}else{
    ipcurrent = connection_platform.ip_apache_view_intern;
   // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
        ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_intern;
    //}
}

let detailsMarkstar = [];
let now                = Moment().subtract(1, "month");  
let dateinitsearchfavorite = now.format('YYYY-MM-DD');
let dateendsearchfavorite = Moment().format("YYYY-MM-DD");

export default function MessageFavoriteModal({clientQueueMax}){
    const InfoUsers = useSelector(state => state.informationusers);
    const [isOpen, setIsOpen] = useState(false);
    const [urlimage, setUrlImage] = useState("");
    const dispatch = useDispatch();
    const MessageFavoritesData = useSelector(state => state.detailsmarkstars);

    const buttonSearchMarkstar = () => {
        var erro = 0;
        const datainit = document.getElementById('date_init_search_favorite').value;
        const datafim = document.getElementById('date_fim_search_favorite').value;
    
        var comparation = Moment(datainit).isBefore(datafim);
    
        if (datainit == "") var erro = 1;
    
        if (datafim == "") var erro = 1;
    
        if (comparation === false) {
          var erro = 1;
          if (datainit === datafim) {
            var erro = 0;
          }
        }
    
        if (erro === 0) {
          dispatch(DetailsMarkstarida(datainit, datafim, clientQueueMax[0].queueCaller))
        }
      }

      const VerifierImage = (urlimage) => {
        setIsOpen(true);
        setUrlImage(urlimage)
        MicroModal.close('modal__mensagens-favoritas_manager_new');
      }

      const CloseImage = () => {
        setIsOpen(false);
        setUrlImage("");
        MicroModal.show('modal__mensagens-favoritas_manager_new');
      }

      if (MessageFavoritesData.length != 0) {
        detailsMarkstar = MessageFavoritesData.detailsmarkstars;
      }

    return (
        <div
          className="modal micromodal-slide"
          id="modal__mensagens-favoritas_manager_new"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__mensagens-favoritas__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__mensagens-favoritas__title"
                >
                  Mensagens favoritas
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__mensagens-favoritas__content"
              >
                <div className="msg-fav__info">
                  <p className="msg-fav__name  is-poppins">
                  {clientQueueMax.length !== 0 ? 
                        clientQueueMax[0].queueContactname !== " " ? convertUnicodeEmoji(clientQueueMax[0].queueContactname):clientQueueMax[0].queueCaller
                        :
                        ""
                    }
                  </p>
                  <i className="material-icons msg-fav__icon">note</i>{" "}
                  <span className="msg-fav__info-text">
                    Total de{" "}
                    <span className="msg-fav__counter">
                      {detailsMarkstar.length}
                    </span>{" "}
                    mensagens
                  </span>
                </div>
                <div className="msg-fav__wrapper">
                  <div className="msg-fav__mp">
                    <div className="msg-fav__mp-ctrL">
                      <p className="msg-fav__mp-text">Período:</p>
                      <div className="msg-fav__mp-date">
                        <div className="msg-fav__mp-date-wrapper">
                          <span className="msg-fav__mp-date-span">De:</span>
                          <input
                            type="date"
                            className="msg-fav__mp-date-start"
                            id="date_init_search_favorite"
                            defaultValue={dateinitsearchfavorite}
                          />
                          <span className="msg-fav__mp-date-span">Até:</span>
                          <input
                            type="date"
                            className="msg-fav__mp-date-end"
                            id="date_fim_search_favorite"
                            defaultValue={dateendsearchfavorite}
                          />
                        </div>
                      </div>
                      <button
                        className="msg-fav__mp-btn"

                        onClick={() => buttonSearchMarkstar()}
                      >
                        Filtrar
                      </button>
                    </div>
                    
                    <div className="msg-fav__mp-result">
                      <ul className="msg-fav__mp-list">
                        {detailsMarkstar.map(dmark =>
                          (() => {
                            var positmessage1 = "";
                            var positmessage2 = "";
                            if (dmark.is_from_agent === true) {
                              positmessage1 = " right";
                            }
                            if (dmark.mimetypeid == "1") {
                              return (
                                <li
                                  key={dmark.id}
                                  className={"msg-fav__mp-item" + positmessage1}
                                >
                                  <p className="msg-fav__mp-time">
                                    <span className="msg-fav__mp-day">
                                      {dmark.data_markstar}
                                    </span>{" "}
                                    -{" "}
                                    <span className="msg-fav__mp-hour">
                                      {dmark.hora_markstar}
                                    </span>
                                  </p>
                                  <div className="msg-fav__mp-bubble">
                                    {dmark.mensagem}
                                    <span className="msg-fav__mp-star material-icons">
                                      star
                                    </span>
                                  </div>
                                </li>
                              );
                            } else {
                              if (dmark.mimetypeid == "2") {
                                if (testJson(dmark.mensagem) === true) {
                                  let json = JSON.parse(dmark.mensagem);
                                  let options = json.options;
                                  let i = 1;
                                  var opcoes = [];
                                  for (i in options) {
                                    opcoes.push(i + " - " + options[i][1]);
                                  }
                                  return (
                                    <li
                                      className={
                                        "msg-fav__mp-item" + positmessage1
                                      }
                                    >
                                      {dmark.mensagem}
                                    </li>
                                  );
                                } else {
                                  return (
                                    <li
                                      className={
                                        "msg-fav__mp-item" + positmessage1
                                      }
                                    >
                                      {dmark.mensagem}
                                    </li>
                                  );
                                }
                              } else if (
                                dmark.mimetypeid == "3" ||
                                dmark.mimetypeid == "5" ||
                                dmark.mimetypeid > "6"
                              ) {
                                let separador = dmark.mensagem.split(".");
                                switch (separador[1]) {
                                  case "jpeg":
                                  case "png":
                                  case "jpg":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div
                                                className="bubble-media__image"
                                                onClick={() =>
                                                  VerifierImage(
                                                    connection_platform.type_connect+'://'+
                                                      ipcurrent+
                                                      dmark.mensagem,
                                                    "dmark"
                                                  )
                                                }
                                              >
                                                {isOpen && (
                                                  <Lightbox
                                                    mainSrc={
                                                      urlimage
                                                    }
                                                    onCloseRequest={() =>
                                                      CloseImage(
                                                        "dmark"
                                                      )
                                                    }
                                                  />
                                                )}
                                                <img
                                                  src={
                                                    connection_platform.type_connect+'://'+
                                                    ipcurrent+
                                                    dmark.mensagem
                                                  }
                                                  alt=""
                                                />
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={JPG}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                { 
                                                          (() => { 
                                                            if(InfoUsers.permdownload === true){
                                                            return(
                                                              <div className="bubble-media__download">
                                                              <a
                                                                href={
                                                                  connection_platform.type_connect+'://'+
                                                                  ipcurrent+
                                                                  dmark.mensagem
                                                                }
                                                                target="_blank"
                                                                download
                                                                className="bubble-media__btnDownload"
                                                              >
                                                                <i className="material-icons">
                                                                  get_app
                                                                </i>
                                                              </a>
                                                            </div>
                                                                           )
                                                            }
                                                          })()    
                                                  }

                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "pdf":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={PDF}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                { 
                                                          (() => { 
                                                            if(InfoUsers.permdownload === true){
                                                            return(
                                                              <div className="bubble-media__download">
                                                              <a
                                                                href={
                                                                  connection_platform.type_connect+'://'+
                                                                  ipcurrent+
                                                                  dmark.mensagem
                                                                }
                                                                target="_blank"
                                                                download
                                                                className="bubble-media__btnDownload"
                                                              >
                                                                <i className="material-icons">
                                                                  get_app
                                                                </i>
                                                              </a>
                                                            </div>
                                                                                       )
                                                            }
                                                          })()    
                                                  }
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "xls":
                                  case "xlsx":
                                  case "xlsm":
                                  case "doc":
                                  case "docx":
                                  case "ppt":
                                  case "pptx":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={XLS}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                { 
                                                          (() => { 
                                                            if(InfoUsers.permdownload === true){
                                                            return(
                                                              <div className="bubble-media__download">
                                                              <a
                                                                href={
                                                                  connection_platform.type_connect+'://'+
                                                                  ipcurrent+
                                                                  dmark.mensagem
                                                                }
                                                                target="_blank"
                                                                download
                                                                className="bubble-media__btnDownload"
                                                              >
                                                                <i className="material-icons">
                                                                  get_app
                                                                </i>
                                                              </a>
                                                            </div>
                                                              )
                                                            }
                                                          })()    
                                                  }
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "wav":
                                  case "mp3":
                                  case "ogg":
                                  case "mpeg":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__playerBar">
                                                <audio controls>
                                                  <source
                                                    src={
                                                      connection_platform.type_connect+'://'+
                                                      ipcurrent+
                                                      dmark.mensagem
                                                    }
                                                    type="audio/ogg"
                                                  />
                                                  <source
                                                    src={
                                                      connection_platform.type_connect+'://'+
                                                      ipcurrent+
                                                      dmark.mensagem
                                                    }
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser.
                                                </audio>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={MP3}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>

                                                { 
                                                          (() => { 
                                                            if(InfoUsers.permdownload === true){
                                                            return(
                                                              <div className="bubble-media__download">
                                                              <a
                                                                href={
                                                                  connection_platform.type_connect+'://'+
                                                                  ipcurrent+
                                                                  dmark.mensagem
                                                                }
                                                                target="_blank"
                                                                download
                                                                className="bubble-media__btnDownload"
                                                              >
                                                                <i className="material-icons">
                                                                  get_app
                                                                </i>
                                                              </a>
                                                            </div>
                                                                          )
                                                            }
                                                          })()    
                                                  }
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  case "mp4":
                                    return (
                                      <li
                                        className={
                                          "msg-fav__mp-item" + positmessage1
                                        }
                                      >
                                        <p className="msg-fav__mp-time">
                                          <span className="msg-fav__mp-day">
                                            {dmark.data_markstar}
                                          </span>{" "}
                                          -{" "}
                                          <span className="msg-fav__mp-hour">
                                            {dmark.hora_markstar}
                                          </span>
                                        </p>
                                        <div className="msg-fav__mp-bubble">
                                          <div className="message left msg-fav__media">
                                            <div className="bubble-media">
                                              <div className="bubble-media__video">
                                                <video
                                                  className="bubble-media__video-frame"
                                                  controls
                                                >
                                                  <source
                                                    className="bubble-media__video-file"
                                                    src={
                                                      connection_platform.type_connect+'://'+
                                                      ipcurrent+
                                                      dmark.mensagem
                                                    }
                                                    type="video/mp4"
                                                  />
                                                  Seu navegador nao suporta esse
                                                  tipo de arquivo.
                                                </video>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={AVI}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        dmark.filesize
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                { 
                                                          (() => { 
                                                            if(InfoUsers.permdownload === true){
                                                            return(
                                                              <div className="bubble-media__download">
                                                              <a
                                                                href={
                                                                  connection_platform.type_connect+'://'+
                                                                  ipcurrent+
                                                                  dmark.mensagem
                                                                }
                                                                target="_blank"
                                                                download
                                                                className="bubble-media__btnDownload"
                                                              >
                                                                <i className="material-icons">
                                                                  get_app
                                                                </i>
                                                              </a>
                                                            </div>
                                                                                      )
                                                            }
                                                          })()    
                                                  }
                                              </div>
                                            </div>
                                          </div>
                                          <span className="msg-fav__mp-star material-icons">
                                            star
                                          </span>
                                        </div>
                                      </li>
                                    );
                                    break;
                                  default:
                                }
                              }
                            }
                          })()
                        )}
                      </ul>
                    </div>
                    
                  </div>
                  
                  <div className="msg-fav__null">
                    {/* <img
                      src="build/images/msg-fav__null.svg"
                      alt=""
                      className="msg-fav__null-img"
                    /> */}
                    <h3 className="is-poppins msg-fav__null-title">
                      Voce não possui{" "}
                      <span className="is-poppins is-poppins--bold">
                        mensagens favoritas.
                      </span>
                    </h3>
                    <p className="msg-fav__null-text">
                      Clique no ícone da estrela no canto inferior de cada
                      mensagem para marcá-la como favorita. Assim, você poderá
                      encontrá-la depois aqui.
                    </p>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
    );
}